<template>
    <div class="container-fluid" id="contenedor-principal-home">
        <CCargandoInformacion v-if="cargandoInformacion" :mostrarError="ocurrioError"></CCargandoInformacion>
        <div v-if="!cargandoInformacion">
            <CSeccion v-for="(seccion) in seccionesDePagina" :key="'seccion-' + seccion.SeccionId + conRender" 
                class=""
                :informacion="{ idElemento: seccion.SeccionId, nombre: seccion.Nombre }"
                :formatosDeSeccion="[{ tipoDeFormato: seccion.FormatoId, contenidos: seccion.Contenidos }]"
                :opciones="{ carrusel: CONFIGURACION_CARRUSEL, menuDeUsuario: menusDeUsuario }"
                :ref="REF_SECCION"></CSeccion>
        </div>
    </div>
</template>
<script>
import CSeccion from "@/components/Intranet/Comun/CSeccion.vue";
import CCargandoInformacion from "@/components/Intranet/Comun/CCargandoInformacion";
import axios from 'axios'
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"

export default {
    beforeRouteEnter (to, from, next) {
        next(async (instanciaVue) => {
            instanciaVue.cargandoInformacion = true;
            const PAGINA_HABILITADA = await Promise.resolve(instanciaVue.usuarioTieneLaPaginaHabilitada({ ruta: to.path }));
            if(!PAGINA_HABILITADA) {
                instanciaVue.irATableroThemis();
                instanciaVue.cargandoInformacion = false;
                comun.mensajeDeAlerta('No tienes acceso a la pagina solicitada', null, null);
            }
        });
    },
    components: {
        CSeccion: CSeccion,
        CCargandoInformacion: CCargandoInformacion
    },
    data() {
        return {
            secciones: [],
            REF_SECCION: 'REFSeccionIntranet',
            CONFIGURACION_CARRUSEL: {
                opciones: {
                        conFondo: true,
                        conTituloCarrusel: { mostrar: false, texto: 'Avisos', estilosCss: 'color: #676666; font-weight: bold;' },
                        conTitulo: { mostrar: false, identificador: 'Titulo' }, // remplazar por propiedades reales del objeto de contenido de la entidad
                        conImagen: { mostrar: true, identificador: 'RutaDeAcceso' }, // remplazar por propiedades reales del objeto de contenido de la entidad
                        conDescripcion: { mostrar: false, identificador: 'Descripcion' }, // remplazar por propiedades reales del objeto de contenido de la entidad
                        configuraciones: { 
                            autoPlay: true,
                            dimensiones: { 
                                0: { items: true, nav: false }, 
                                600:{ items: true, nav: false },
                                800: { items: true, nav: false },
                                1200: { items: true, nav: false }
                            },
                            estilosCss: 'height: 40em; border-radius: 10px 10px 10px 10px;'
                        } 
                }
            },
            cargandoInformacion: true,
            NUMERO_NOTICIAS_A_MOSTRAR: 1,
            PAGINA_INICIO_INTRANET: 11,
            ocurrioError: false,
            obtuvoPermisos: false,
            menusConPermisos: [],
            conRender: 0
        }
    },
    methods: {
        irATableroThemis: function() {
            const RUTA_TABLERO = '/Tablero/SistemasWeb'; 
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = RUTA_TABLERO;
            a.click();
        },
        usuarioTieneLaPaginaHabilitada: async function({ ruta }) {
            let habilitada = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.VerificarSiTieneHabilitadaPagina;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { 
                    RutaDePagina: this.$route.fullPath
                };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, TieneHabilitadaLaPagina } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    habilitada = TieneHabilitadaLaPagina
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return habilitada;
        },
        // SECCION PARA FUNCIONES
        iniciarProcesoCargaDeInformacion: async function() { 
            try {
                this.cargandoInformacion = true;
                const CARGO_CONTENIDOS_SIN_ERROR = await Promise.resolve(this.obtenerPaginaConSeccionesYContenidosBD());
                const CARGO_MENUS_SIN_ERROR = await Promise.resolve(this.obtenerMenusConSubmenusDB());
                this.cargandoInformacion = !(CARGO_CONTENIDOS_SIN_ERROR && CARGO_MENUS_SIN_ERROR);
                this.ocurrioError = this.cargandoInformacion;
                console.log('formatos::',this.secciones);
                $('html, body').animate({ scrollTop:0 }, 'slow');
            }
            catch(excepcion) {
                console.log(excepcion);
            }
        },
        obtenerMenusConSubmenusDB: async function() {
            let procesoSinError = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.ObtenerMenusDeIntranet;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { PaginaDeInicioId: this.PAGINA_INICIO_INTRANET, EsPrueba: false };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, Menus } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    //console.log('objMenus::',Menus);
                    await Promise.resolve(this.convertirMenusAObjetosDeFormatos({ menus: Menus }));
                    procesoSinError = true;
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return procesoSinError;
        },
        convertirMenusAObjetosDeFormatos: async function({ menus }) {
            if(this.campoRequeridoEsValido(menus)) {
                let seccionDeSubmenus = {};
                let submenusConFormatos = [];
                menus.forEach(menuDB => {
                    if(this.campoRequeridoEsValido(menuDB.Submenus)) {
                        // Esta seccion como tal no es un registro de la tabla seccion por eso el id se queda como -1
                        seccionDeSubmenus.SeccionId = -1;
                        seccionDeSubmenus.Nombre = 'AREAS INTRANET';
                        seccionDeSubmenus.FormatoId = 35;
                        submenusConFormatos = menuDB.Submenus.map(submenuDB => {
                            const { TipoIcono, Titulo, OrdenDelSubmenu, SubmenusQueMePertenecen } = submenuDB;
                            let submenuObj = {};
                            submenuObj.Icono = TipoIcono.Icono;
                            submenuObj.Titulo = this.obtenerTituloOSubtituLoDeEnlace({ tituloCompletoSubmenu: Titulo, esTitulo: true });
                            submenuObj.SubTitulo = this.obtenerTituloOSubtituLoDeEnlace({ tituloCompletoSubmenu: Titulo, esTitulo: false });
                            submenuObj.identificador = OrdenDelSubmenu;
                            submenuObj.mostrarEnlacesOcultos = false;
                            submenuObj.enlaces = this.obtenerSubmenusConFormato({ submenusHijos: SubmenusQueMePertenecen });
                            return submenuObj;
                        });
                        seccionDeSubmenus.Contenidos = submenusConFormatos;
                    }
                });
                this.secciones.push(seccionDeSubmenus);
            }
        },
        /**
         * Funcion encargada de obetener el subtitulo del submenu principal de la secciond e tarjetas de enlaces de la areas de intranet.
         * logica = titulo y subtitulo se almacena en el campo [006Titulo] (Titulo) de la entidad [006SubmenuId] (Submenu) identificados
         * separados por el caracter '-', la posicion [0] es para el titulo del submenu y la posicion [1] para el subtitulo.
         * @param {String} tituloCompletoSubmenu [titulo compuesto del submenu padre]
         * @returns {String} subtitulo [valor para el subtitulo del menu padre mostrado en la seccion de trajetas de enlaces]
         */
        obtenerTituloOSubtituLoDeEnlace: function({ tituloCompletoSubmenu, esTitulo }) {
            let subtitulo = tituloCompletoSubmenu;
            if(this.campoRequeridoEsValido(tituloCompletoSubmenu)) {
                const ELEMENTOS_DE_TITULO = tituloCompletoSubmenu.split('-');
                if(this.campoRequeridoEsValido(ELEMENTOS_DE_TITULO))
                    subtitulo = (esTitulo) ? ELEMENTOS_DE_TITULO[0] : ELEMENTOS_DE_TITULO[1];
            }
            return subtitulo;
        },
        obtenerSubmenusConFormato: function({ submenusHijos }) { 
            let enlaces = [];
            if(this.campoRequeridoEsValido(submenusHijos)) {
                enlaces = submenusHijos.map(submenuDB => {
                    const { Titulo, RutaParaAccesar } = submenuDB;
                    let submenuObj = {};
                    submenuObj.Titulo = Titulo;
                    submenuObj.RutaParaAccesar = RutaParaAccesar;
                    return submenuObj;
                });
            }
            return enlaces;
        },
        obtenerPaginaConSeccionesYContenidosBD: async function() {
            let procesoSinError = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.ObtenerContenidosDeIntranetAdministracion;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { 
                    RutaDeLaPaginaDeIntranet: this.$route.fullPath, 
                    PorAreaDeUsuario: false,
                    EsPrueba: false 
                };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, PaginaDeIntranet } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    console.log('objPagina::',PaginaDeIntranet);
                    await Promise.resolve(this.convertirContenidosAObjetosDeFormatos({ pagina: PaginaDeIntranet }));
                    procesoSinError = true;
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return procesoSinError;
        },
        convertirContenidosAObjetosDeFormatos: async function({ pagina }) {
            if(this.campoRequeridoEsValido(pagina)) {
                const { SeccionesDeIntranet } = pagina;
                if(this.campoRequeridoEsValido(SeccionesDeIntranet)) {
                    this.secciones = SeccionesDeIntranet.map(sBD => {
                        let seccionObj = {};
                        seccionObj.SeccionId = sBD.SeccionDeIntranetId;
                        seccionObj.Nombre = sBD.Nombre;
                        seccionObj.FormatoId = sBD.TipoFormato.TipoFormatoId;
                        let contenidosDeSeccionObj = sBD.Contenidos.map(cBD => {
                            let contenidoObj = {};
                            contenidoObj.id = cBD.ContenidoDeIntreanetId;
                            contenidoObj.Titulo = cBD.Comunicado.Titulo;
                            contenidoObj.RutaDeAcceso = cBD.Comunicado.RutaDeImagen;
                            contenidoObj.Descripcion = `<strong>${ cBD.Comunicado.SubTitulo }</strong> ${ cBD.TextoDelContenido }`;
                            contenidoObj.Fecha = moment(cBD.Comunicado.Fecha).format('YYYY-MM-DD');
                            contenidoObj.RutaDeArchivo = cBD.ArchivosDeContenidoIntranet[0].Ruta;
                            return contenidoObj;
                        });
                        seccionObj.Contenidos = contenidosDeSeccionObj;
                        return seccionObj;
                    });
                   /*  this.secciones.push(seccionConFormato); */
                }
            }
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        getModulosConPermisosBD: async function() {
            let procesoSinError = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.GetModulos;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { 
                    EsPrueba: false 
                };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, modulos } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    this.menusConPermisos = this.campoRequeridoEsValido(modulos) ? modulos.map(p => (p.Nombre)) : [];
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return procesoSinError;
        },
    },
    async mounted() {
        await Promise.resolve(this.iniciarProcesoCargaDeInformacion());
    },
    async created() {
        await Promise.resolve(this.getModulosConPermisosBD());
    },
    computed: {
        seccionesDePagina() {
            return this.secciones;
        },
        menusDeUsuario() {
            return this.menusConPermisos;
        }
    },
    watch: {
        /* '$store.state.Login_PermisosDelSistema': function() {
            //console.log('permisos::',this.$store.state.Login_PermisosDelSistema);
            if(this.campoRequeridoEsValido(this.$store.state.Login_PermisosDelSistema) && !this.obtuvoPermisos) {
                console.log('this.$store.state.Login_PermisosDelSistema::',this.$store.state.Login_PermisosDelSistema)
                this.menusConPermisos = this.$store.state.Login_PermisosDelSistema.map(p => (p.Nombre));
                this.obtuvoPermisos = true;
                this.conRender ++;
                //console.log('menusConPermisosssssssssssssssssssssssssssssssssssssss::',this.menusConPermisos);
            }
        } */
    }
}
</script>
<style scoped>
.espacio-entre-secciones {
    padding-top: 5vmin;
}

#contenedor-principal-home {
    /* padding: 2vmin 16vmin 0vmin 16vmin; */
    padding: 0vmin 0vmin 0vmin 0vmin;
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Comun/Estructura/Home/CHome.vue